import React from 'react';
import SurveyItem from '../../util/SurveyItem';
import SurveyField from '../SurveyField';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import withCheckForEnablement, {
  WithCheckForEnablementInjectedProps,
} from '../hoc/withCheckForEnablement';
import SurveyItemContainer from '../SurveyItemContainer';
import { withIsReadOnly, WithIsReadOnlyInjectedProps } from '../Contexts';
import { FieldProps } from 'formik';
import getSurveyItemTestId from '../../util/getSurveyItemTestId';
import { getTestProps } from '../../../../util/testProps';
import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import { v4 as uuid } from 'uuid';

export const testIds = {
  checkbox: (linkId: string, additionalData?: string) =>
    getSurveyItemTestId(linkId, additionalData),
};

const styles = (theme: Theme) =>
  createStyles({
    labelText: {
      color: theme.palette.text.secondary,
    },
  });

export interface FieldComponentOwnProps {
  isReadOnly: boolean;
  inputProps: React.InputHTMLAttributes<HTMLInputElement>;
  label: string;
  disabled: boolean;
}

export type FieldComponentProps = FieldComponentOwnProps & FieldProps<any>;

class FieldComponent extends React.PureComponent<FieldComponentProps> {
  private _id: string;
  constructor(props: FieldComponentProps) {
    super(props);

    this._id = uuid();
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { form, field } = this.props;

    form.setFieldValue(field.name, event?.target?.checked || false);
  };

  render() {
    const {
      field: { value, onChange, ...inputProps },
      form,
      label,
      disabled,
      ...toPass
    } = this.props;

    return (
      <Checkbox
        onChange={this.handleChange}
        checked={!!value}
        {...inputProps}
        label={label}
        disabled={disabled}
        id={this._id}
        {...toPass}
        {...getTestProps(testIds.checkbox(inputProps.name))}
      />
    );
  }
}

export interface BooleanOwnProps {
  surveyItem: SurveyItem;
}

export type BooleanProps = WithStyles<typeof styles> &
  BooleanOwnProps &
  WithCheckForEnablementInjectedProps &
  WithIsReadOnlyInjectedProps;

class Boolean extends React.PureComponent<BooleanProps> {
  render() {
    const { surveyItem, isEnabled, isReadOnly } = this.props;

    if (!isEnabled) return null;

    return (
      <SurveyItemContainer surveyItem={surveyItem}>
        <SurveyField
          responseAnswerType={surveyItem.responseValueType}
          name={surveyItem.link}
          component={FieldComponent}
          disabled={isReadOnly}
          label={surveyItem.label}
        />
      </SurveyItemContainer>
    );
  }
}

export default withStyles(styles)(
  withCheckForEnablement(withIsReadOnly(Boolean)),
);
